<template>
  <div class="recharge">
    <div class="header">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">账户余额</span>
      <van-icon name="setting-o" @click="goSetting" />
    </div>
    <div class="balance">
      <div class="item">账户余额（元）</div>
      <div class="value">{{ balanceInfo.balance }}</div>
    </div>
    <div class="amount">
      <div class="item">
        <div :class="100 | filterRecharge(rechargeValue)" @click="() => pickMoney(100)"><span>100</span><span>元</span></div>
        <div :class="200 | filterRecharge(rechargeValue)" @click="() => pickMoney(200)"><span>200</span><span>元</span></div>
      </div>
      <div class="item">
        <div :class="300 | filterRecharge(rechargeValue)" @click="() => pickMoney(300)"><span>300</span><span>元</span></div>
        <div :class="500 | filterRecharge(rechargeValue)" @click="() => pickMoney(500)"><span>500</span><span>元</span></div>
      </div>
      <div class="inputArea">
        <div :class="rechargeValue === 0 ? 'inputSelect' : 'input'">
          <input v-model="moneyValue" type="number" class="moneyInput" :style="rechargeValue === 0 ? 'color: #3B86FF' : ''" placeholder="充值金额" @click="inputMoney">
          <span class="unit" :style="rechargeValue === 0 ? 'color: #3B86FF' : ''">元</span>
        </div>
      </div>
    </div>
    <div class="tips">
      <div class="head">使用说明</div>
      <div class="tip">1.充值余额长期有效，不可提现，不计利息，不可转赠；</div>
      <div class="tip">2.充值余额可在单位食堂使用，按照食堂消费规则进行扣费；</div>
      <div class="tip">3.当您的账户余额小于订单所需支付金额时，您将被限制进入食堂消费，请您关注并在余额不足时及时充值；</div>
      <div class="tip">4.充值结果及记录可在消费记录中查询。</div>
    </div>
    <div class="btns" @click="onRecharge">
      <div style="background-color: #3b86ff;">
        立即充值
      </div>
    </div>
  </div>
</template>

<script>
import { myBalance, accountRecharge } from '@/api/user';
export default {
  name: 'Recharge',
  filters: {
    filterRecharge(val, rechargeValue) {
      if (rechargeValue === val) {
        return 'select';
      } else {
        return 'default';
      }
    }
  },
  data() {
    return {
      remindChecked: false,
      text: '',
      moneyValue: '',
      rechargeValue: 100,
      enterMoney: false,
      balanceInfo: {}
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      myBalance({}).then(res => {
        this.balanceInfo = res.data;
      });
    },
    goBack() {
      this.$router.push({ name: 'user' });
    },
    pickMoney(rechargeValue) {
      this.rechargeValue = rechargeValue;
    },
    inputMoney() {
      this.rechargeValue = 0;
    },
    goSetting() {
      this.$router.push({ name: 'paySetting' });
    },
    onRecharge() {
      // this.$toast.loading({
      //   message: '提交中...',
      //   forbidClick: true,
      //   loadingType: 'spinner',
      //   duration: 0
      // });
      const rechargeFee = this.rechargeValue || this.moneyValue;
      const that = this;
      if (rechargeFee) {
        accountRecharge({ rechargeFee }).then(res => {
          if (res.code === 200) {
            WeixinJSBridge.invoke('getBrandWCPayRequest', {
              'appId': res.data.appId, // 公众号ID，由商户传入
              'timeStamp': res.data.timeStamp, // 时间戳，自1970年以来的秒数
              'nonceStr': res.data.nonceStr, // 随机串
              'package': res.data.package,
              'signType': res.data.signType, // 微信签名方式：
              'paySign': res.data.paySign
            },
            function(res) {
              if (res.err_msg == 'get_brand_wcpay_request:ok') {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                that.$toast.clear();
                that.getInfo();
              } else {
                that.$toast.clear();
              }
            });
          } else {
            this.$toast.clear();
          }
        });
      } else {
        this.$toast({
          message: '请输入/选择充值金额'
        });
      }
    }
  }
};
</script>

<style lang="less">
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}
.recharge {
  width: 100%;
  height: calc(100vh);
  overflow-x: hidden;
  box-sizing: border-box;
  padding-bottom: 0.1rem;
  .header {
    height: 0.44rem;
    font-size: 0.17rem;
    font-weight: 400;
    line-height: 0.24rem;
    color: #333333;
    background: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.135rem;
    .confirm {
      color: #3B86FF;
    }
  }

  .balance {
    background-color: #FFFFFF;
    padding: 0.105rem 0 0.09rem 0;
    border-top: 1px solid #EFEFF4;
    .item {
      text-align: center;
      .change_val(font-size, 28);
    }
    .value {
      text-align: center;
      .change_val(font-size, 42);
      color: #3B86FF;
    }
  }

  .remind {
    padding: 0.09rem 0;

    .van-field__label {
      color: #333;
    }
  }

  .amount {
    padding: 0.09rem 0;
    background-color: #FFFFFF;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .item {
      display: flex;
      justify-content: center;
      .default {
        border: 1px solid rgba(112, 112, 112, 0.20392156862745098);;
        color: #707070;
        background: rgba(0, 0, 0, 0.05);
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        .change_margin(margin, 10, 18);
        .change_val(width, 200);
        .change_val(height, 86);

        span:first-child {
          .change_val(font-size, 36);
        }
        span:last-child {
          .change_val(font-size, 16);
          margin-top: 0.06rem;
          margin-left: 0.02rem;
        }
      }
      .select {
        border: 1px solid #3B86FF;
        color: #3B86FF;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        .change_margin(margin, 10, 18);
        .change_val(width, 200);
        .change_val(height, 86);

        span:first-child {
          .change_val(font-size, 36);
        }
        span:last-child {
          .change_val(font-size, 16);
          margin-top: 0.06rem;
          margin-left: 0.02rem;
        }
      }
    }

    .inputArea {
      display: flex;
      justify-content: center;
      .input {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid rgba(112, 112, 112, 0.20392156862745098);
        border-radius: 10px;
        margin: 0.02rem 0;
        .change_val(width, 438);
        .change_val(height, 96);
        .moneyInput {
          background:none;
          outline:none;
          border:none;
          text-align: center;
          .change_val(font-size, 34);
          .change_val(width, 204);
          .change_val(height, 48);
        }

        .unit {
          margin-left: 0.02rem;
          margin-top: 0.12rem;
          .change_val(font-size, 20);
        }
      }
      .inputSelect {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #3B86FF;
        border-radius: 10px;
        margin: 0.02rem 0;
        .change_val(width, 438);
        .change_val(height, 96);
        .moneyInput {
          background:none;
          outline:none;
          border:none;
          text-align: center;
          .change_val(font-size, 34);
          .change_val(width, 204);
          .change_val(height, 48);
        }

        .unit {
          margin-left: 0.02rem;
          margin-top: 0.12rem;
          .change_val(font-size, 20);
        }
      }
    }
  }

  .tips {
    .change_margin(margin, 26, 14);

    .head {
      .change_val(font-size, 28);
      .change_val(line-height, 40);
      margin-bottom: 0.02rem;
    }

    .tip {
      .change_val(font-size, 20);
      .change_val(line-height, 33);
      margin-bottom: 0.026rem;
    }
  }

  .btns {
    display: flex;
    justify-content: space-between;
    //margin-top: 0.1rem;
    margin-bottom: 0.2rem;
    padding: 0rem 0.28rem;
    > div {
      width: 100%;
      height: 0.47rem;
      font-size: 0.18rem;
      color: #fff;
      line-height: 0.47rem;
      text-align: center;
    }
    div:first-child {
      background: #FFBE00;
      border: 1px solid rgba(5, 5, 5, 0.08235294117647057);
      opacity: 1;
      border-radius: 5px;
    }
    div:last-child {
      background: #2DCC2C;
      border: 1px solid rgba(5, 5, 5, 0.08235294117647057);
      opacity: 1;
      border-radius: 5px;
    }
  }

}

</style>
